/*
 * @name: 自定义组件渲染组件
 */
import * as React from "react";
import { connect } from "react-redux";
import { Collapse } from "@whalecloud/fdx";
import { css } from "emotion";
import { getParentElementWithChildren, getElement } from '@whalecloud/page-builder-core/selectors';
import isEqual from "lodash/isEqual";
import Element from "@whalecloud/page-builder-core/components/Element";

const { Panel } = Collapse;
const headerStyle = css({
  '> .ant-collapse-header': {
    borderBottom: '1px solid #e0e0e0',
  },
});
const collapseWrapStyle = css({
  margin: '0 !important',
  '> .ant-collapse-item > .ant-collapse-header': {
    borderBottom: '1px solid #e0e0e0',
  },
  '> .ant-collapse-item > .ant-collapse-content': {
    background: 'white',
  },
});

/**
 * @param  {Object} element 当前元素
 * @param  {} value   组件值，如果自定义组件是表单控件，则在使用时Form会传入该参数，组件需要接收
 * @param  {Function} onChange 组件值改变触发的方法，如果自定义组件是表单控件，则在使用时Form会传入该参数，组件需要接收
 */
const CardContainer = ({ element, parentEl, elementStyle }) => {
  const { componentSettings = {}, settings, className = '' } = element?.data;
  const {
    backgroundColor,
    radius,
    bordered: selfBordered = true,
  } = componentSettings;
  const {
    margin: {
      desktop: { top, bottom, left, right },
    },
  } = settings;
  const { formItemSettings: collapseSettings = {} } = parentEl?.data;
  const { bordered, expandIconPosition } = collapseSettings || {};
  const condition = parentEl.type === 'collapse';
  const wrapStyle: any = { margin: '0 !important' };
  const headerCondition = selfBordered ? '' : headerStyle;
  if (!condition && selfBordered) {
    wrapStyle.borderBottom = '1px solid #e0e0e0';
  }

  const panelStyle = condition
    ? {
      background: backgroundColor,
      borderRadius: radius,
      margin: `${top}px ${right}px ${bottom}px ${left}px`,
    }
    : {
      background: 'white',
    };

  return (
    <Collapse
      defaultActiveKey={condition ? [] : ['0']}
      bordered={condition ? false : selfBordered}
      style={{
        ...elementStyle,
        ...wrapStyle
      }}
      className={`${bordered ? 'formBuilder-show-collapse' : ''} ${condition ? collapseWrapStyle : ''
        } ${className}`}
      expandIconPosition={expandIconPosition}
    >
      <Panel
        key="0"
        disabled={condition ? false : !false}
        showArrow={
          condition ? parentEl.data?.formItemSettings?.showArrow : false
        }
        header={element.elements.map((v) => {
          if (v.type === 'text') {
            return (
              <div key={v.id}>
                <Element id={v.id} />
              </div>
            );
          }
          return null;
        })}
        style={panelStyle}
        className={condition ? '' : headerCondition}
      >
        {element.elements.map((v) => {
          if (v.type === 'block') {
            return (
              <div key={v.id}>
                <Element id={v.id} />
              </div>
            );
          }
          return null;
        })}
      </Panel>
    </Collapse>
  );
};

export default connect<any, any, any>(
  (state, props) => {
    const element = getElement(state, props.elementId);
    const parentEl = getParentElementWithChildren(state, element.id);
    const elementStyle = props.elementStyle;
    return { element: { ...element, elements: element.elements.map(id => getElement(state, id)) }, parentEl, elementStyle }
  },
  null,
  null,
  { areStatePropsEqual: isEqual }
)(CardContainer);
